export const getPassengerInitials = (passengerName = "") =>
  passengerName
    .split(" ")
    .map((partOfTheName) => partOfTheName[0])
    .slice(0, 2)
    .join("");
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";